export const isValidPositiveNumber = (number) => !!(number && !isNaN(number) && number > 0);

export const isDecimalNumber = (number) => /^[0-9.]+$/.test(number);
